import { useState } from 'react';
import { motion } from 'framer-motion';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <>
      {/* Top Contact Bar */}
      <div className="bg-black/80 text-white py-2 px-4 md:px-8 fixed top-0 left-0 right-0 z-50 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto flex justify-between items-center text-sm">
          <div className="flex items-center gap-6">
            <a href="mailto:bigfinancesrl@gmail.com" className="flex items-center gap-2 hover:text-primary transition-colors whitespace-nowrap">
              <i className="ri-mail-line"></i>
              <span className="hidden md:inline">bigfinancesrl@gmail.com</span>
            </a>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-white font-bold tracking-widest uppercase text-sm">BIG FINANCE</span>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <motion.nav
        initial={{ y: 0 }}
        animate={{ y: 0 }}
        className={`fixed top-10 left-0 right-0 z-40 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-8 py-4">
          <div className="max-w-7xl mx-auto flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/17719955-25e7-42d9-a7c2-73289b899813.png" 
                alt="Big Finance Srl Logo" 
                className="h-12 md:h-14 w-auto object-contain transition-all duration-300"
              />
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              <button
                onClick={() => scrollToSection('home')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled ? 'text-gray-dark hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('chi-siamo')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled ? 'text-gray-dark hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Chi Siamo
              </button>
              <button
                onClick={() => scrollToSection('servizi')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled ? 'text-gray-dark hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Servizi
              </button>
              <button
                onClick={() => scrollToSection('eventi')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled ? 'text-gray-dark hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Eventi & Motorsport
              </button>
              <button
                onClick={() => scrollToSection('marketing')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled ? 'text-gray-dark hover:text-primary' : 'text-white hover:text-primary'
                }`}
              >
                Marketing
              </button>
              <button
                onClick={() => scrollToSection('contatti')}
                className="bg-primary text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-primary/90 transition-all whitespace-nowrap"
              >
                Contattaci
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center ${
                scrolled ? 'text-gray-dark' : 'text-white'
              }`}
              aria-label="Menu"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="lg:hidden bg-white shadow-lg"
          >
            <div className="px-4 py-6 space-y-4">
              <button
                onClick={() => scrollToSection('home')}
                className="block w-full text-left text-gray-dark hover:text-primary transition-colors py-2 whitespace-nowrap"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('chi-siamo')}
                className="block w-full text-left text-gray-dark hover:text-primary transition-colors py-2 whitespace-nowrap"
              >
                Chi Siamo
              </button>
              <button
                onClick={() => scrollToSection('servizi')}
                className="block w-full text-left text-gray-dark hover:text-primary transition-colors py-2 whitespace-nowrap"
              >
                Servizi
              </button>
              <button
                onClick={() => scrollToSection('eventi')}
                className="block w-full text-left text-gray-dark hover:text-primary transition-colors py-2 whitespace-nowrap"
              >
                Eventi & Motorsport
              </button>
              <button
                onClick={() => scrollToSection('marketing')}
                className="block w-full text-left text-gray-dark hover:text-primary transition-colors py-2 whitespace-nowrap"
              >
                Marketing
              </button>
              <button
                onClick={() => scrollToSection('contatti')}
                className="bg-primary text-white px-6 py-3 rounded-full font-semibold hover:bg-primary/90 transition-all w-full whitespace-nowrap"
              >
                Contattaci
              </button>
            </div>
          </motion.div>
        )}
      </motion.nav>
    </>
  );
}